import { gql } from '@apollo/client';

import { CREATE_ADS_WITH_CREATIVES_AD_ENTITY_FIELDS } from './createAdsWithCreativesAdEntityFields';
import { CREATE_ADS_WITH_CREATIVES_CREATIVE_ITEM_FIELDS } from './createAdsWithCreativesCreativeItemFields';
import { CREATE_ADS_WITH_CREATIVES_OPERATION_ERROR_FIELDS } from './createAdsWithCreativesOperationErrorFields';

export const CREATE_ADS_WITH_CREATIVES_AD_ITEM_FIELDS = gql`
  fragment CreateAdsWithCreativesAdItemFields on CreateAdsWithCreativesAdItem {
    operationStatus
    error {
      ...CreateAdsWithCreativesOperationErrorFields
    }
    adEntity {
      ...CreateAdsWithCreativesAdEntityFields
    }
    creativeEntity {
      ...CreateAdsWithCreativesCreativeItemFields
    }
  }
  ${CREATE_ADS_WITH_CREATIVES_OPERATION_ERROR_FIELDS}
  ${CREATE_ADS_WITH_CREATIVES_AD_ENTITY_FIELDS}
  ${CREATE_ADS_WITH_CREATIVES_CREATIVE_ITEM_FIELDS}
`;
